import { DATE_PRESETS } from "../util/datePresets"

export const GLOBAL_BUILD_TEMPLATES = [
  {
    id: "trade-sales",
    presetName: "Trade/Sales",
    builderType: "CUSTOMER",
    tag: "Trade",
    prevPurchDatePreset: DATE_PRESETS.LAST_2_7_YEARS,
  },
  {
    id: "loyalty-brand-awareness",
    presetName: "Loyalty Brand/Awareness",
    builderType: "CUSTOMER",
    tag: "General",
    prevPurchDatePreset: DATE_PRESETS.LAST_90_DAYS,
  },
  {
    id: "service-sold-not-serviced",
    presetName: "Service (Sold Not Serviced)/Sales or Leads",
    builderType: "CUSTOMER",
    tag: "Service",
    nevSerPrevPurch: true,
  },
  {
    id: "service-overdue",
    presetName: "Service (Service Overdue)/Sales or Leads",
    builderType: "CUSTOMER",
    tag: "Service",
    nevSerPrevPurch: true,
    nevSerDatePreset: DATE_PRESETS.LAST_12_MONTHS,
  },
  {
    id: "loyalty-offer-model",
    presetName: "Loyalty/Offer or Model/Sales or Leads",
    builderType: "CUSTOMER",
    tag: "General",
    prevPurchDatePreset: DATE_PRESETS.LAST_2_5_YEARS,
  },
  {
    id: "unsold-leads",
    presetName: "Unsold Leads/Sales",
    builderType: "CUSTOMER",
    tag: "General",
    prevPurchDatePreset: DATE_PRESETS.LAST_90_DAYS,
  },
  {
    id: "conquest-sales",
    presetName: "Conquest/Sales",
    builderType: "CUSTOMER",
    tag: "General",
    prevPurchDatePreset: DATE_PRESETS.LAST_7_YEARS_OR_MORE,
  },
  {
    id: "trade-3pd-sales",
    presetName: "Trade 3PD/Sales",
    builderType: "AUDIENCE",
    tag: "Trade",
    geoRadius: 20,
    brandOwners: true,
    inferredPurchase2to7: true,
  },
  {
    id: "new-3pd-sales",
    presetName: "New 3PD/Sales",
    builderType: "AUDIENCE",
    tag: "New",
    geoRadius: 20,
    brandOwners: true,
    inferredPurchase2to7: true,
  },
  {
    id: "custom-preorder-sales",
    presetName: "Custom or Preorder/Sales",
    builderType: "AUDIENCE",
    tag: "General",
    geoRadius: 20,
    brandOwners: true,
  },
  {
    id: "new-conquest-sales",
    presetName: "New Conquest/Sales",
    builderType: "AUDIENCE",
    tag: "New",
    geoRadius: 20,
    brandOwners: true,
    excludeSalesYears: 7,
  },
  {
    id: "service-3pd-sales",
    presetName: "Service/Sales or Leads",
    builderType: "AUDIENCE",
    tag: "Service",
    geoRadius: 20,
    brandOwners: true,
  },
  {
    id: "recruitment-awareness",
    presetName: "Recruitment/Awareness",
    builderType: "AUDIENCE",
    tag: "Recruitment",
    geoRadius: 20,
    demographics: true,
  },
]

export const getTemplateById = (templateId) =>
  GLOBAL_BUILD_TEMPLATES.find((template) => template.id === templateId)
